<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Recharge History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Recharge History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <!-- <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
                    class="fa fa-filter"></i>Filter</a> -->
                Recharge History
                <div class="card-tools">
                  <!-- <button class="btn btn-info" @click="exportFile()">
                      <i class="fas fa-download"></i> Export
                    </button> -->
                </div>
              </div>
              <form @submit.prevent="getUsers" method="GET" novalidate>
                <div class="card-body" v-if="showFilter">
                  <div class="form-row">
                    <div class="col-md-6">
                      <!-- Date range -->
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="created_at"
                          >Date range</label
                        >
                        <div class="col-md-9">
                          <date-picker
                            type="datetime"
                            input-class="form-control"
                            v-model="filter.created_at"
                            range
                            lang="en"
                            format="YYYY-MM-DD hh:mm:ss"
                            confirm
                            id="created_at"
                            value-type="YYYY-MM-DD hh:mm:ss"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-9 offset-md-3">
                          <button type="submit" class="btn btn-common m-2px">
                            <i class="fas fa-search"></i> Search
                          </button>
                          <button
                            type="reset"
                            class="btn btn-warning"
                            @click="resetFilter()"
                          >
                            <i class="fas fa-undo"></i> Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table common-table">
                    <thead>
                      <tr>
                        <th>Transaction ID</th>
                        <th>Payment Time</th>
                        <th class="text-center">Amount (TK)</th>
                        <th class="text-left">Payment Status</th>
                      </tr>
                    </thead>
                    <tbody class="users-list">
                      <tr v-for="(val, index) in list.data">
                        <td>
                          {{
                            !_.isEmpty(val.mer_transactionid)
                              ? val.mer_transactionid
                              : ""
                          }}
                        </td>
                        <td>{{ val.payment_time }}</td>
                        <td class="text-center">
                          <span class="amount">
                            {{ val.total_amount }}
                          </span>
                        </td>
                        <td class="text-left">
                          <span class="paid" :class="val.class">{{
                            val.payment_status
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="p-4"
                  v-if="_.isEmpty(list.data) && !list.is_loading"
                >
                  <div class="alert alert-default-warning" role="alert">
                    No data found!
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <vue-pagination
                  :pagination="list"
                  v-if="list.total > list.per_page"
                  @paginate="getRechargeList()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
span.amount {
  font-weight: 800;
  font-size: 14px;
  color: black;
}
.paid {
  /* display: block;
  color: black; */
}

.success {
  background: #caffd6;
  color: #119a30;
  /* border-radius: 100px; */
  /* padding: 4px 15px 3px; */
  border-radius: 100px;
  text-align: center;
  padding: 4px 15px 3px;
  display: inline-block;
  font-size: 13px;
}
.in-progress {
  background: #ffe9dd;
  /* color: #119A30; */
  color: #e31e0af5;
  border-radius: 100px;
  text-align: center;
  padding: 4px 15px 3px;
  display: inline-block;
  font-size: 13px;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "RechargeHistory",
  metaInfo: {
    title: "Recharge History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [],
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),

  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    this.getRechargeList();

    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getRechargeList();
    });
  },

  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getRechargeList() {
      this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      this.list.data = [
        // {
        //   subject: "#92762990 Get A Call Back", lastUpdate: '12/02/2022', status: 'Open'
        // },
      ];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        query.cuid = subscriber.username;
        // console.log("QueryParams::", query);
        axios({
          method: "get",
          url: "/get-recharge-history",
          params: query,
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => {
            //console.log("Res::", response)
            this.list = response.data;
            this.list.data =
              this.list.data.length > 0
                ? this.list.data.map((o) => {
                    o.payment_time = moment(o.payment_time).format(
                      "DD/MM/YYYY"
                    );
                    o.class =
                      o.payment_status == "SUCCESS" ? "success" : "in-progress";
                    return o;
                  })
                : [];
            // this.list.total = data.length;
            // console.log("list data::", this.list)
            this.list.is_loading = false;
          })
          .catch((error) => {
            this.list.is_loading = false;
          });
      }
    },

    apiUsage(query = null) {},

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getTicketList();
    },
  },
};
</script>
